import React, {useEffect, useContext} from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./KioskLaborTrackPage.scss"
import Title from "./Title";
import Banner from "./Banner";
import ScanForm from "./ScanForm";
import Center from "./Center";
import {useParams, useHistory} from "react-router";
import AppConfigContext, { checkFeatureEnabled } from "../../store/app-config";
import AdminContext from "../../store/admin-context";
import { useRouteBusinessSpaceSync } from "../../store/useRouteBusinessSpaceSync";
import {FEATURE_ADMIN_SCAN_AND_GO}from "../../constants";

export default function KioskLaborTrackPage() {
    let { businessSpace, nodeId } = useParams<{ businessSpace: string, nodeId: string }>();
    const history = useHistory();
    const adminContext = useContext(AdminContext);
    const {selectedNode} = adminContext;
    const appConfigContext = useContext(AppConfigContext);
    const {config, region, stage} = appConfigContext;
    
    useRouteBusinessSpaceSync();

    useEffect(() => {
        if(config !== null || undefined){
            if (!checkFeatureEnabled(config, FEATURE_ADMIN_SCAN_AND_GO, region, stage, selectedNode, businessSpace)){
                history.push("/");
            }
        }
      }, [selectedNode, config, businessSpace]);

    return (
        <Center>
            <Title nodeId={nodeId} />
            <Banner>
                <ScanForm nodeId={nodeId} businessSpace={businessSpace} />
            </Banner>
        </Center>
    );
}
